import { render } from "./parte4.vue?vue&type=template&id=7acd3199&scoped=true"
import script from "./parte4.vue?vue&type=script&lang=js"
export * from "./parte4.vue?vue&type=script&lang=js"

import "./parte4.vue?vue&type=style&index=0&id=7acd3199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acd3199"]])

export default __exports__